import { RegisterModule } from '@/typings/common'
import {
  ParticipantsState,
  ParticipantsGetters,
  ParticipantsMutations,
  ParticipantsActions,
} from './store'
import {
  createMapper,
  registerModule as vuexRegisterModule,
  Module,
} from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: ParticipantsState,
    getters: ParticipantsGetters,
    mutations: ParticipantsMutations,
    actions: ParticipantsActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as participantsStoreModule,
  mapper as participantsMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
